document.addEventListener('DOMContentLoaded', function () {
    let timeout;
    const woocommerceContainer = document.querySelector('.woocommerce');

    woocommerceContainer.addEventListener('change', function (event) {
        if (event.target && event.target.matches('input.qty')) {
            if (timeout !== undefined) {
                clearTimeout(timeout);
            }
            timeout = setTimeout(function () {
                document.querySelector("[name='update_cart']").click(); // trigger cart update
            }, 500);
        }
    });

    // Block negative qty on single product forms and show WooCommerce error
    document.querySelectorAll('form.cart').forEach(function (form) {
        form.addEventListener('submit', function (e) {
            const qtyInput = form.querySelector('input.saldo');
            const qty = parseInt(qtyInput && qtyInput.value, 10);

            if (isNaN(qty) || qty < 0) {
                e.preventDefault();

                let errorContainer = document.querySelector('.woocommerce-error');
                if (!errorContainer) {
                    errorContainer = document.createElement('ul');
                    errorContainer.className = 'woocommerce-error';
                    const woocommerceContainer = document.querySelector('.woocommerce');
                    if (woocommerceContainer) {
                        woocommerceContainer.prepend(errorContainer);
                    }
                }

                // Remove previous error messages
                errorContainer.innerHTML = '';

                // Add new error message
                const errorItem = document.createElement('li');
                errorItem.textContent = 'Foutieve invoer: Een negatieve waarde is niet toegestaan.';
                errorContainer.appendChild(errorItem);
            }
        });
    });
});

